export enum TicketingCollaboratorTypes {
  CONTRIBUTOR = 'contributor',
  EDITOR = 'editor',
}

export type TicketingPermissionTypes = 'ticket_contributor' | 'ticket_editor';
